export default "__VITE_ASSET__40b6b889__"